import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Switch, Route, useLocation, useRouteMatch } from 'react-router-dom';

import ViewTitle from '../../common/view-title';
import Loader from '../../common/loader';
import NotFound from '../../common/not-found';

import helpers from '../../utils/helpers';

import KardexMenu from './kardex-menu';
import KardexIndex from './kardex-index';
import KardexDetail from './kardex-detail';

const useStyles = makeStyles(() => ({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    }
}));

const Kardex = () => {

    const classes = useStyles();
    const { pathname } = useLocation();
    const { path } = useRouteMatch();
    const [state, setState] = useState({
        loading: true,
        permissions: {}
    });

    useEffect(() => {
        const validatePermissions = () => {
            const permissions = helpers.getPermissions(pathname);
            setState(prev => ({ ...prev, permissions, loading: false }));
        }

        validatePermissions();
    }, []);

    if (state.loading) return <Loader />;

    if (!state.permissions?.read_attr) return <NotFound />;

    return (
        <div className={classes.root}>
            <ViewTitle sedeFlag title='Kardex' />

            <Switch>
                <Route exact path={path}><KardexMenu permissions={state.permissions} /></Route>
                <Route exact path={`${path}/index`}><KardexIndex permissions={state.permissions} /></Route>
                <Route exact path={`${path}/:id`}><KardexDetail permissions={state.permissions} /></Route>
                <Route path={`${path}/*`}><NotFound /></Route>
            </Switch>
        </div>
    );
}

export default Kardex;